export const typeUserb2b = {
    getUsersb2b: '[userb2b] get_user_b2b',
    createUsersb2b: '[userb2b] create_user_b2b',
    updateUsersb2b: '[userb2b] update_user_b2b',
    deleteUsersb2b: '[userb2b] delete_user_b2b',
}
